/**
 * @fileoverview Brand icon component using CSS mask.
 * Renders the Clockwork brand icon as a masked div element,
 * allowing the icon to inherit the current text color.
 * @module components/brand-icon
 */

import { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Brand icon component.
 * Displays the Clockwork brand SVG using CSS mask technique.
 * The icon color is controlled by the parent's text color (currentColor).
 * @param props - Standard HTML div attributes plus className
 * @returns Accessible brand icon div element
 * @example
 * <BrandIcon className="h-6 w-6 text-primary" />
 */
export function BrandIcon({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("bg-current inline-block", className)}
      style={{
        maskImage: "url(/brand-icon.svg)",
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskImage: "url(/brand-icon.svg)",
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        backgroundColor: "currentColor",
      }}
      role="img"
      aria-label="Brand Icon"
      {...props}
    />
  );
}
